/* eslint-disable react/no-children-prop */
import { Grid } from '@material-ui/core';
import { Text } from 'components/styleguide';
import { Trans } from 'react-i18next';
import { useRootTranslation } from 'utils/hooks';

const rootT = 'drawers.importCommercialTracksDrawer.ready';

const ReadyToImport = () => {
  const t = useRootTranslation(rootT);

  return (
    <Grid
      container
      xs={12}
      direction="column"
      justifyContent="center"
      alignContent="center"
      alignItems="center"
      style={{ height: 'calc(100vh - 520px)', minHeight: 220 }}
    >
      <Grid item>
        <Text color="green" variant="formLabel" children={t('title')} bold />
      </Grid>
      <Grid item>
        <Trans i18nKey={`${rootT}.click`}>
          <Text variant="formLabel" />
          <Text variant="formLabel" bold />
        </Trans>
      </Grid>
      <Grid item>
        <Text variant="formLabel" children={t('hint')} />
      </Grid>
      <Grid item style={{ marginTop: 8 }}>
        <Text color="orange" variant="formLabel" children={t('warning1')} />
      </Grid>
      <Grid item>
        <Text color="orange" variant="formLabel" children={t('warning2')} />
      </Grid>
    </Grid>
  );
};

export default ReadyToImport;
